import React, { useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import EnhancedTableHead from '../../CommonComponents/TableComponents/EnhancedTableHead';
import {
  getComparator,
  stableSort,
} from '../../CommonComponents/TableComponents/TableUtils';
import Assignment from './Assignment';
import { showUserForm } from '../../redux/actions/common';
import ProductTableRow from './ProductTableRow';

const headCells = [
  {
    id: 'productName',
    numeric: false,
    label: 'ProductName',
  },
  {
    id: 'Manager',
    numeric: false,
    label: 'Assigned Managers',
  },
  {
    id: 'Action',
    numeric: false,
    label: 'Action',
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  title: {
    marginRight: 30,
    marginTop: 12,
    float: 'left',
  },
  assignButtonWidth: {
    width: 250,
  },
}));

const ProductsTable = ({
  products, client, showForm, clients, visibleForm,
}) => {
  const classes = useStyles();
  const [product, setProductName] = useState({ productName: '', id: '' });
  const [clientName, setClientName] = useState('');
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('Name');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const showProductAssignment = (id) => {
    const cName = clients.find((item) => item.value === client.value).text
    setClientName(cName)
    const pName = products.find((item) => item.id === id).productName
    setProductName({ productName: pName, id })
    showForm(true);
  }

  const finalRows = products.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  return (
    <div className={classes.root}>
      <div>
        <Paper className={classes.paper}>
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size="medium"
              aria-label="enhanced table"
            >
              <EnhancedTableHead
                headCells={headCells}
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {stableSort(finalRows, getComparator(order, orderBy))
                  .map((row) => (
                    <ProductTableRow
                      row={row}
                      showProductAssignment={showProductAssignment}
                    />
                  ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={products.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </Paper>
        {visibleForm
          ? (
            <Assignment
              title="Assign Products to Manager"
              product={product}
              clientName={clientName}
            />
          )
          : null}
      </div>
    </div>
  );
};

const mapState = (state) => ({
  products: state.common.products,
  visibleForm: state.common.showUserForm,
  clients: state.common.clients,
});

const mapActions = {
  showForm: showUserForm,
};

export default connect(mapState, mapActions)(ProductsTable);
